<template>
    <div class="art-rec-news" data-spm="fd-d" data-spm-stop="init">
        <header class="rec__head">
            <h2>推荐阅读</h2>
        </header>
        <feed-list-new
            :article-id="articleId" 
            :businessConfig="businessConfig"
            :config="config">
        </feed-list-new>
    </div>
</template>

<script>
/**
 * @description 目前仅用于文章页推荐阅读
 */

import FeedListNew from './feed-list-new.vue'

export default {
    name: "ArtFeed",
    props:{
        //文章ID
        articleId: {
            type: [Number, String],
            default: 0,
        },
        //通用参数map，传递给feed流封装组件
        config: {
            type: Object,
            default: {},
        },
    },
    data () {
        return {
            // feed流的业务配置，视频是否大图
            businessConfig: {
                isBigVideoStyle: true
            }
        }
    },
    components: {
        FeedListNew
    },
}
</script>

<style lang="less" rel="stylesheet/less">
    .art-rec-news {
        padding-bottom: 12px;
        border-bottom: 8px solid #f5f5f5;
        .feed-list-area-feed {
            padding: 0;
            .feed-item {
                border: 0;
            }
        }
    }
    .rec__head {
        position: relative;
        padding-top: 26px;
        padding-bottom: 8px;
        padding-right: 26px;
        padding-left: 26px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        h2 {
            color: #111;
            font-size: 36px;/*px*/
            font-weight: 500;
            line-height: 50px;/*px*/
            font-family: PingFangSC, PingFang SC;
        }
    }
</style>